import { isRowSent } from '@features/buyer-line-items-pagination/utils/is-row-sent';
import type {
  ID,
  LineItem,
  Lot,
  LotChanges,
} from 'types';
import type { LotsIdErrors } from '@features/buyer-line-items-pagination/types/id-error-state';

const itemsByIdCache = new WeakMap<Lot, Map<string, LineItem>>();

const originalItemsById = (lot?: Lot): Map<string, LineItem> => {
  if (!lot) return new Map();
  let items = itemsByIdCache.get(lot);
  if (!items) {
    items = new Map(lot.line_items.map(item => [String(item.id), item]));
    itemsByIdCache.set(lot, items);
  }
  return items;
};

export interface HasSentRowErrorsParams {
  changes: Record<ID, LotChanges>;
  lotsIdErrors: LotsIdErrors;
  originalLots: Lot[];
}

export const hasSentRowErrors = ({ changes, lotsIdErrors, originalLots }: HasSentRowErrorsParams): boolean => (
  Object.entries(changes ?? {}).some(([lotId, lotChanges]) => {
    const lotErrors = lotsIdErrors?.[lotId];
    if (!lotErrors) return false;

    const erroredRowIds = Object.keys(lotChanges?.line_items ?? {}).filter(id => lotErrors[id]?.length);
    if (!erroredRowIds.length) return false;

    const items = originalItemsById(originalLots.find(lot => String(lot.id) === lotId));
    return erroredRowIds.some(lineItemId => isRowSent({ lineItemId, lotChanges, originalItemsById: items }));
  })
);
